import {useEffect, useState} from "react";
import styles from './Warnings.module.css';
import HttpService from "../Services/HttpService";
import {getRowStyle, toPersianDigits} from "../../Component/Tools/tools";
import image_not_found from './Image-not-found.png';
import BottomSheet from "../../Component/Sheets/BottomSheet";
import Carousel from "../../Component/Carousel/Carousel";
import Button from "../../Component/Button/Button";
import {toast} from "react-toastify";

function Warnings() {
    const [warningDto, setWarningDto] = useState([])
    useEffect(() => {
        HttpService.get('Api/WarningPeople').then(res => {
            setWarningDto(res.data);
        }).catch(reason => {
           toast.error('هیچ موردی نیست');
        });
    }, []);
    const imgSrc = (jsonImage) => {
        try {
            return HttpService.API_SERVER + 'Media/DownloadFile?path=' + (JSON.parse(jsonImage || '[]')[0] || '');
        } catch {
            return image_not_found;
        }
    };

    const [openAdvertisment, setOpenAdvertisment] = useState(false);
    const [infoAd, setInfoAd] = useState({});
    const onTapAd = (index) => {
        setInfoAd(warningDto[index])
        setOpenAdvertisment(true);
    }

    const [selectedMessage, setSelectedMessage] = useState(null);
    const handleOpenMessage = (message) => {
        setSelectedMessage(message);
    };
    const handleCloseMessage = () => {
        setSelectedMessage(null);
    };

    const onTapOkWarning = async (listIds) => {
        console.log(listIds)
      await HttpService.post('Api/SeenWarnigns',listIds).then(async res => {
          setOpenAdvertisment(false);
          await HttpService.get('Api/WarningPeople').then(res => {
              setWarningDto(res.data);
          }).catch(reason => {
              toast.error('هیچ موردی نیست');
              setWarningDto([]);
          });
      }).catch(reason => {
          toast.error('خطا در ارسال به سرور')
      });
    }

    return (<div className={styles.container}>
        {warningDto.map((ad, index) => (
            <div key={ad.adId} className={styles.container_ad} onClick={() => onTapAd(index)}>
                <img src={imgSrc(ad.adJsonImage)} alt={'image ad'}/>
                <h2>{ad.adTitle}</h2>
                <h3>{toPersianDigits(ad.adPhone)}</h3>
                <p>{toPersianDigits(ad.messages.length) + " "}اخطار</p>
            </div>
        ))}

        <BottomSheet isOpen={openAdvertisment} onClose={() => setOpenAdvertisment(false)}>
            <div className={styles.container_show_ad}>
                <div style={{width: "300px"}}><Carousel data={JSON.parse(infoAd.adJsonImage ?? "[]")}/></div>
                <div className={styles.container_info}>
                    <h2>{infoAd.adTitle}</h2>
                    <p>{toPersianDigits(infoAd.adPhone)}</p>

                    <div className={styles.container_table_messages}>
                        <table className={styles.table}>
                            <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>شماره تلفن</th>
                                <th>موضوع</th>
                                <th>پیغام</th>
                                <th>زمان ارسال</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                infoAd?.messages?.map((message, indexMessage) => (
                                    <tr key={indexMessage}>
                                        <td>{toPersianDigits(indexMessage + 1)}</td>
                                        <td>{toPersianDigits(message.phone)}</td>
                                        <td>{toPersianDigits(message.tag)}</td>
                                        <td
                                            className={styles.messageCell}
                                            onClick={() => handleOpenMessage(message.message)}
                                            title="برای مشاهده کامل کلیک کنید"
                                        >
                                            {message.message.length > 25
                                                ? message.message.substring(0, 25) + '...'
                                                : message.message}
                                        </td>
                                        <td>{new Date(message.createAt).toLocaleString('fa-IR')}</td>
                                    </tr>
                                ))
                            }
                            </tbody>
                        </table>
                    </div>

                    <Button text={'بازبینی شد'} onClick={() => onTapOkWarning(infoAd.messages.map(x => x.id))}/>
                </div>
            </div>

            {/* پاپ‌آپ نمایش کامل پیام */}
            {selectedMessage && (
                <div className={styles.modalOverlay} onClick={handleCloseMessage}>
                    <div
                        className={styles.modalContent}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h3>متن کامل پیام</h3>
                        <p>{selectedMessage}</p>
                        <Button text={'بستن'} onClick={handleCloseMessage}/>
                    </div>
                </div>
            )}
        </BottomSheet>
    </div>);
}

export default Warnings;